import { Pdfgqr } from '../models/pdfgqr.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PdfgenerateqrService {
  dato: Pdfgqr[];
  constructor() {
    this.dato = [];
  }
}
